import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "../Signup/Style";

const INIT_STATE = {
  email: "",
  password: "",
  error: null,
  loading: false
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INIT_STATE };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value.trim() });
  }

  handleSubmit(firebase, e) {
    e.preventDefault();
    this.setState({ loading: true });
    firebase
      .signIn(this.state.email, this.state.password)
      .then(user => this.props.history.push("/dashboard"))
      .catch(error => this.setState({ error, loading: false }));
  }

  render() {
    const { classes } = this.props;
    const { email, password, error, loading } = this.state;
    const formNotValid = email === "" || password === "";
    const firebase = this.context;
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mx={2}
      >
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4">
            Sign In
          </Typography>
          <form
            onSubmit={this.handleSubmit.bind(this, firebase)}
            className={classes.form}
          >
            <TextField
              name="email"
              label="Enter your email"
              fullWidth
              required
              variant="outlined"
              margin="normal"
              value={email}
              onChange={this.handleChange}
              autoComplete="email"
              autoFocus
            />
            <TextField
              name="password"
              label="Enter your password"
              fullWidth
              required
              variant="outlined"
              margin="normal"
              value={password}
              onChange={this.handleChange}
              type="password"
            />
            <Box my={2}>
              <Button
                size="large"
                fullWidth
                variant="contained"
                color="primary"
                disabled={formNotValid || loading}
                type="submit"
              >
                Log In
              </Button>
            </Box>
            {error && (
              <Typography color="error" paragraph align="center">
                {error.message}
              </Typography>
            )}

            <Link className={classes.link} to="/pwreset">
              Forgot your password?
            </Link>

            <Link className={classes.link} to="/signup">
              Don't have an account? Sign Up.
            </Link>
          </form>
        </Paper>
      </Box>
    );
  }
}

Login.contextType = FirebaseContext;
export default withStyles(myStyles)(Login);
